import React, { useEffect, useState } from "react";
import "./CareerCourseModule.css";
import { useNavigate, useParams } from "react-router";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { message, Progress, Spin, Tag } from "antd";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import QuizIcon from "@mui/icons-material/Quiz";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArticleIcon from "@mui/icons-material/Article";
import axios from "axios";
import { BaseUrl, AssesmentUrl } from "../../Constants/Constants";
import { useStateValue } from "../../../Reducer/reducer";

const CareerCourseModule = () => {
  const [courseName, setCourseName] = useState("");
  const [expanded, setExpanded] = React.useState(false);
  const [expandedAss, setExpandedAss] = React.useState(false);
  const [courseModule, setCourseModule] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Assesment, setAssesment] = useState([]);
  const [{ UserID }, dispatch] = useStateValue();
  const MAX_ATTEMPTS = 3;

  const navigate = useNavigate();
  const { id, groupId } = useParams(); // id = career_course_id

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleAssessmentAccordion = (panel) => (event, isExpanded) => {
    setExpandedAss(isExpanded ? panel : false);
  };

  // ✅ Check if all modules (parts) are completed
  const isAllModulesCompleted =
    courseModule.length > 0 &&
    courseModule.every((part) => part.learning_status === true);

  useEffect(() => {
    setLoading(true);

    // 1️⃣ Get Course Name
    axios
      .post(
        `${BaseUrl}career-course-mapping/findOne`,
        { careerCourseId: id },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.data.statuscode === 200) {
          setCourseName(res.data.data.title);
        }
      })
      .catch((err) => console.log(err.message));

    // 2️⃣ Get Course Parts & Training Modules
    axios
      .post(
        `${BaseUrl}career-course-parts/findOneByCareerCourseId`,
        { career_course_id: id, user_id: UserID },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.data.statuscode === 200) {
          setCourseModule(normalizeCourseData(res.data.data));
        }
      })
      .catch((err) => console.log(err.message))
      .finally(() => setLoading(false));

    // 3️⃣ Get Course Tracker (completion)
    axios
      .post(
        `${BaseUrl}career-tracker/getAllCareerTrackerByUserId`,
        { userId: UserID },
        { withCredentials: true }
      )
      .then((res) => console.log(res.data, "trackerResp"))
      .catch((err) => console.log(err.message));

    // 4️⃣ Get Assessments
    axios
      .post(
        `${AssesmentUrl}career_dev_list_course_assessment`,
        {
          course_id: id, //Id want to changefor python we need to pass as course_id only
          user_id: UserID,
        },
        { withCredentials: true }
      )
      .then((res) => {
        setAssesment(res.data.data);
        console.log("assesment structure", res.data);
      })
      .catch((err) => message.error(err.message));
  }, [id, UserID]);

  const handleAsessmentClick = (item) => {
    if (item.assessment_count >= MAX_ATTEMPTS) {
      message.warning("Your attempts are finished");
      return;
    }

    navigate(
      `/career-program/group/${groupId}/course/${id}/assessment/${item.assessment_id}`,
      {
        state: {
          no_of_questions: item.no_of_questions,
          duration: item.assessment_duration,
          assessment_name: item.assessment_name,
        },
      }
    );
  };

  const activeAssessments = Assesment.filter(
    (a) => a.assessment_status === "true"
  );

  const normalizeCourseData = (data) => {
    return data.map((part) => {
      const trainingWithOrder = part.training.map((t, index) => ({
        ...t,
        __order: index, // preserve initial order
      }));

      return {
        ...part,
        training: trainingWithOrder.sort((a, b) => a.__order - b.__order),
      };
    });
  };

  return (
    <div className="courseModuleMainDiv">
      {/* Breadcrumb */}
      <div className="courseBreadcrumb">
        <span
          className="breadcrumbLink"
          onClick={() => navigate(`/career-program`)}
        >
          Modules
        </span>
        <ArrowForwardIosIcon className="breadcrumbArrow" />
        {courseName && <span className="breadcrumbCurrent">{courseName}</span>}
      </div>

      {loading ? (
        <div className="courseLoader">
          <Spin size="large" />
        </div>
      ) : (
        <>
          {/* Header */}
          <div className="courseHeader">
            <div className="courseIconWrapper">
              <MenuBookIcon className="courseHeaderIcon" />
            </div>
            <div className="courseHeaderContent">
              <h1 className="courseTitle">{courseName}</h1>
              <p className="courseSubtitle">
                Explore course modules and Boost Your Career
              </p>
            </div>
          </div>

          {/* Course Modules */}
          {courseModule.length > 0 && (
            <div className="courseModulesSection">
              <div className="sectionHeader">
                <AutoAwesomeIcon className="sectionIcon" />
                <h2 className="sectionTitle">Parts</h2>
              </div>
              <div className="coursesAccordion">
                {courseModule.map((item, key) => {
                  const previousPart = courseModule[key - 1];

                  const isPrevModuleCompleted =
                    previousPart &&
                    previousPart.training.some(
                      (t) => t.learning_status === true
                    );

                  const isModuleLocked = key !== 0 && !isPrevModuleCompleted;

                  return (
                    <Accordion
                      key={key}
                      expanded={expanded === `panel${key}` && !isModuleLocked}
                      onChange={
                        !isModuleLocked
                          ? handleChange(`panel${key}`)
                          : undefined
                      }
                      className={`modernAccordion ${
                        isModuleLocked ? "disabledModule" : ""
                      }`}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel-content"
                        id="panel-header"
                      >
                        <div className="accordionHeaderContent">
                          <div className="partNumberBadge">{`Part ${
                            key + 1
                          }`}</div>

                          <div className="accordionHeadingWrapper">
                            <p className="accordionHeading">{item.partTitle}</p>
                          </div>
                        </div>

                        {isModuleLocked && (
                          <span className="comingSoonText">
                            Complete previous Parts
                          </span>
                        )}
                      </AccordionSummary>

                      <AccordionDetails>
                        <div className="courseSourceDiv">
                          {item.training.map((e, k) => {
                            const hasCompletedBefore = item.training
                              .slice(0, k)
                              .some((t) => t.learning_status === true);

                            const isTopicLocked =
                              k !== 0 && !hasCompletedBefore;

                            return (
                              <div
                                key={k}
                                onClick={() =>
                                  !isTopicLocked &&
                                  navigate(
                                    `/career-program/group/${groupId}/course/${id}/pages/${e.id}?partId=${item.partId}`
                                  )
                                }
                                className={`courseItemCard ${
                                  isTopicLocked ? "disabledModule" : ""
                                }`}
                              >
                                <div className="courseItemContent">
                                  <div
                                    className={`courseItemIcon ${
                                      e.type === "mp4"
                                        ? "videoIcon"
                                        : "documentIcon"
                                    }`}
                                  >
                                    {e.type === "mp4" ? (
                                      <PlayCircleOutlinedIcon />
                                    ) : (
                                      <ArticleIcon />
                                    )}
                                  </div>

                                  <div className="courseItemInfo">
                                    <p className="courseItemName">{e.name}</p>

                                    <div className="courseItemMeta">
                                      {e.type === "mp4" && e.time && (
                                        <span className="courseItemTime">
                                          <AccessTimeIcon className="timeIcon" />
                                          {e.time}
                                        </span>
                                      )}

                                      <span
                                        className={`courseItemType ${
                                          e.type === "mp4"
                                            ? "typeVideo"
                                            : "typeDocument"
                                        }`}
                                      >
                                        {e.type === "mp4"
                                          ? "Video"
                                          : "Document"}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* ✔ Show completion indicator only when topic is completed */}
                                {e.learning_status && (
                                  <div className="courseItemProgress">
                                    <Progress
                                      type="circle"
                                      percent={100}
                                      width={40}
                                      strokeColor={{
                                        "0%": "#667eea",
                                        "100%": "#764ba2",
                                      }}
                                      showInfo={false}
                                    />
                                    <CheckCircleOutlineOutlinedIcon className="completedIcon" />
                                  </div>
                                )}

                                {/* Lock message */}
                                {isTopicLocked && (
                                  <span className="comingSoonText">
                                    Finish previous topic
                                  </span>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </div>
            </div>
          )}

          {/* Assessments */}
          {/* Assessments */}
          {isAllModulesCompleted ? (
            activeAssessments.length > 0 && (
              <div className="assessmentSection">
                <div className="sectionHeader">
                  <QuizIcon className="sectionIcon assessmentSectionIcon" />
                  <h2 className="sectionTitle">Assessments</h2>
                </div>

                <div className="assessmentAccordion">
                  <Accordion className="modernAccordion assessmentAccordionItem">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className="accordionHeaderContent">
                        <div className="partNumberBadge assessmentBadge">
                          <QuizIcon />
                        </div>
                        <p className="accordionHeading">
                          Click here to take the assessment!
                        </p>
                      </div>
                    </AccordionSummary>

                    {activeAssessments.map((item, key) => {
                      let tagColor = "default";
                      let tagText = "Not Attempted";

                      if (item.previous_passing_status === "pass") {
                        tagColor = "green";
                        tagText = "Passed";
                      } else if (item.previous_passing_status === "fail") {
                        tagColor = "red";
                        tagText = "Failed";
                      }

                      const isAttemptFinished =
                        item.assessment_count >= MAX_ATTEMPTS;

                      return (
                        <AccordionDetails key={key}>
                          <div
                            onClick={() =>
                              !isAttemptFinished && handleAsessmentClick(item)
                            }
                            className={`assessmentItemCard ${
                              isAttemptFinished ? "disabledAssessment" : ""
                            }`}
                          >
                            <div className="assessmentItemContent">
                              <div className="assessmentItemIcon">
                                <EditNoteOutlinedIcon />
                              </div>

                              <div className="assessmentItemInfo">
                                <span className="assessmentItemHint">
                                  Attempts: {item.assessment_count} /{" "}
                                  {MAX_ATTEMPTS}
                                </span>

                                <p className="assessmentItemName">
                                  {item.assessment_name}
                                </p>

                                <span className="assessmentItemHint">
                                  Click to start assessment
                                </span>
                              </div>
                            </div>

                            <Tag
                              color={tagColor}
                              className="assessmentStatusTag"
                            >
                              {tagText}
                            </Tag>

                            {isAttemptFinished && (
                              <Tag color="red" className="assessmentStatusTag">
                                Attempts Finished
                              </Tag>
                            )}

                            <ArrowForwardIosIcon className="assessmentArrow" />
                          </div>
                        </AccordionDetails>
                      );
                    })}
                  </Accordion>
                </div>
              </div>
            )
          ) : (
            /* 🔒 Locked – module-style text only */
            <div className="courseModulesSection">
              <div className="sectionHeader">
                <QuizIcon className="sectionIcon assessmentSectionIcon" />
                <h2 className="sectionTitle">Assessments</h2>
              </div>

              <Accordion className="modernAccordion disabledModule">
                <AccordionSummary>
                  <div className="accordionHeaderContent">
                    <div className="partNumberBadge assessmentBadge">
                      <QuizIcon />
                    </div>

                    <div className="accordionHeadingWrapper">
                      <p className="accordionHeading">
                        Complete all Parts to unlock assessment
                      </p>
                    </div>
                  </div>
                </AccordionSummary>
              </Accordion>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CareerCourseModule;
